module.exports = __webpack_public_path__ + "fonts/Inter-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter-Regular.woff
// module id = 1174
// module chunks = 0